<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Pembelian
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0 d-flex justify-center">
              <div style="height: calc(100vh - 220px); overflow-y: auto;">
                <v-card v-if="process.load && Object.keys(detail).length < 1"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
  
              <div v-if="!process.load && Object.keys(detail).length > 0" class="px-4">
                <v-card 
                  flat
                  min-height="calc(100vh - 245px)"
                  width="500"
                  style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                  <v-card-text class="black_one">
                    <div class="text-center mb-5">
                      <div class="fs-18 font-weight-bold mb-2">
                        {{ detail.supplier_name }}
                      </div>
                      <div class="fs-14 font_weight_600 mb-3">
                        {{ detail.supplier_address }}
                      </div>
                      <div class="fs-14 font_weight_600">
                        PEMBELIAN/{{ detail.number }}
                      </div>
                      <div class="fs-13">
                        {{ detail.date | date }}
                      </div>
                    </div>
                    <!-- <div style="border: 2px dashed #e0e0e0;" class="my-3"></div>
                    <div class="d-flex align-center mb-4">
                      <div class="fs-14 font_weight_600">
                        Pasar Baru Grosir
                      </div>
                      <div class="ml-auto">
                        Transaksi Ke <span class="fs-14 font_weight_600 ml-2">99</span>
                      </div>
                    </div> -->
                    <v-card flat style="border: 2px dashed #e0e0e0; border-radius: 8px;" class="mb-5" v-for="(item, index) in list" :key="index">
                      <v-card-text class="pa-3">
                        <div class="fs-14 mb-2">
                          {{ item.item_name }}
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diminta oleh
                          </div>
                          <div class="fs-14 ml-auto">
                            Dapur Produksi (blm api)
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Harga
                          </div>
                          <div class="fs-14 ml-auto">
                            {{ item.item_purchase_price | price }} / {{ item.satuan }}
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diskon
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 0
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Sub Total
                          </div>
                          <div class="fs-14 ml-auto">
                            {{ item.item_purchase_price | price }}
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Qty
                          </div>
                          <div class="fs-14 ml-auto">
                            {{ item.item_qty*1 }} {{ item.satuan }}
                          </div>
                        </div>
                        <div class="d-flex align-center font-weight-bold">
                          <div class="fs-14">
                            Total
                          </div>
                          <div class="fs-14 ml-auto">
                            {{ ((item.item_purchase_price*1)*(item.item_qty*1)) | price }}
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <!-- <v-card flat style="border: 2px dashed #e0e0e0; border-radius: 8px;" class="mb-5">
                      <v-card-text class="pa-3">
                        <div class="fs-14 mb-2">
                          Pisang Raja Nangka
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diminta oleh
                          </div>
                          <div class="fs-14 ml-auto">
                            Dapur Produksi
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Harga
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 60.000 / Kilogram
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diskon
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 0
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Sub Total
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 60.000
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Qty
                          </div>
                          <div class="fs-14 ml-auto">
                            10 Kilogram
                          </div>
                        </div>
                        <div class="d-flex align-center font-weight-bold">
                          <div class="fs-14">
                            Total
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 600.000
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card flat style="border: 2px dashed #e0e0e0; border-radius: 8px;" class="mb-5">
                      <v-card-text class="pa-3">
                        <div class="fs-14 mb-2">
                          Daging Merah Potong Empat
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diminta oleh
                          </div>
                          <div class="fs-14 ml-auto">
                            Dapur Produksi
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Harga
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 100.000 / Kilogram
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Diskon
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 0
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Sub Total
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 100.000
                          </div>
                        </div>
                        <div class="d-flex align-center mb-1">
                          <div class="fs-14">
                            Qty
                          </div>
                          <div class="fs-14 ml-auto">
                            10 Kilogram
                          </div>
                        </div>
                        <div class="d-flex align-center font-weight-bold">
                          <div class="fs-14">
                            Total
                          </div>
                          <div class="fs-14 ml-auto">
                            Rp 1.000.000
                          </div>
                        </div>
                      </v-card-text>
                    </v-card> -->
                  </v-card-text>
                </v-card>
                <!-- <v-speed-dial
                  v-model="fab"
                  :top="top"
                  :bottom="bottom"
                  :right="right"
                  :left="left"
                  :direction="direction"
                  :open-on-hover="hover"
                  :transition="transition"
                  style="position: absolute; top: calc(100vh - 150px);"
                >
                  <template v-slot:activator>
                    <v-btn
                      v-model="fab"
                      color="blue darken-2"
                      dark
                      fab
                      elevation="0"
                    >
                      <v-icon v-if="fab">
                        mdi-close
                      </v-icon>
                      <v-icon v-else>
                        mdi-share-circle
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-btn
                    fab
                    dark
                    small
                    color="green"
                  >
                    <v-icon>mdi-whatsapp</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    dark
                    small
                    color="indigo"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-speed-dial> -->
              </div>

            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        direction: 'top',
        detail: {},
        list: [],
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
        item: [],

        dialog: {
          form: false,
          fullscreen: false
        
        },
        total_nominal: 0,

        form: {
          id: '',
          outlet_id: '',
          location_id: '',

          date: '',
          status: '',
          // items: []

        },
        selected: [],
        menu2: false,
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,

          image: false,
          load: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      // this.fetchBagian()
      // this.fetch()
      this.fetchDetail()
      this.form.outlet_id = this.user.cat_title === 'Owner' ? this.outlet.outlet_id : this.outlet.outlet_id
      this.fetch()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/pembelian/pengadaan/data`, { params })
        .then(response => {
          let res = response.data

          // this.process.load = false
          // this.fetch()

          if (res.status === 200) {
            this.detail = res.results.data[0]
          }
        })
      },
      async fetch () {
        this.process.load = true

        let params = {
          limit: 100000000000000,
          po_id: this.$route.params.id
        }

        await get(`pos/pembelian/pengadaan/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.list = []
            res.results.data.map((item) => {
              this.list.push({ 
                ...item,
                total: (item.item_qty*1)*(item.item_purchase_price*1),
                item_qty: (item.item_qty*1),
                qty_satuan: (item.item_qty*1) + '/' + item.satuan,
              })
            })
            this.process.load = false

          }
        })
      },
    }
  }
</script>